'use strict';

module.exports = function (element, message, notificationType) {
    var notificationHtml = `<div
                                class="l-container alert alert-${notificationType} alert-dismissible mb-4 fade show"
                                role="alert"
                            >
                                <span class="alert-${notificationType}-icon"></span>
                                <p class="alert-content">
                                    ${message}
                                </p>
                                <button
                                    type="button"
                                    class="close
                                    close-icon"
                                    data-dismiss="alert"
                                    aria-label="Close"
                                >
                                </button>
                            </div>`;

    $(element).empty().append(notificationHtml);

    /* This comment is because the feedback on the notifications is still not signed off,
    ** for now UX team wants the notification not faded out
    */
    // setTimeout(function () {
    //     $(element).empty();
    // }, mls ? mls : 2000);
};
